import request from "../config/network/requestFinalCoursewareApiService";

// 素材添加时，判断文件是否存在
export function isHasFile({ name }) {
  return request({
    url: `resource/exists?names[]=${name}`,
    method: "get",
  });
}
// demo
export function demo({ name }) {
  return request({
    url: `resource/exists?names[]=${name}`,
    method: "get",
  });
}

